//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import Rater from 'vux/src/components/rater/index.vue'
import MyRater from '@/components/rater/rater.vue'
import sliderItem from '@/components/slider/slider.vue'
import downloadImgs from '@/mixins/downloadImgs'
export default {
  mixins: [downloadImgs],
  data() {
    return {
      currentLevelValue: 0,
      isHistory: false,
      rule: {
        custom: {
          currentLevelValue: {
            required: () => '请打分',
          },
        },
      },
    }
  },
  props: {
    question: {
      type: Object,
      default() {
        return {}
      },
    },
    index: {
      type: Number,
    },
    readonly: {
      type: Boolean,
    },
    showScore: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Rater,
    MyRater,
    sliderItem,
  },
  created() {
    console.log(this.question)
  },
  mounted() {
    this.filterHistory()
    this.$validator.localize('zh_CN', this.rule)
    if (this.question.v_answer) {
      let tenantId =
        this.question.v_answer.currentValue &&
        this.question.v_answer.currentValue.join('')
      if (!tenantId) {
        this.currentLevelValue = 0
      } else {
        this.question.options.forEach((option, index) => {
          if (option.tenantId === tenantId) {
            this.currentLevelValue = index + 1
          }
        })
      }
    }
  },
  computed: {
    ...mapGetters(['questionnaireList']),
    currentLevel() {
      return Number(this.question.level)
    },
    value() {
      if (this.currentLevelValue == 0) {
        return ''
      } else {
        return this.currentLevelValue
      }
    },
    icon() {
      let iconfont = 'xingxing'
      switch (this.question.style) {
        case 'star':
          iconfont = 'xingxing'
          break
        case 'heart':
          iconfont = 'heart'
          break
        case 'smile':
          iconfont = 'smile'
          break
        case 'like':
          iconfont = 'dianzan'
          break
        default:
          iconfont = 'xingxing'
      }
      return `<span class="iconfont icon-${iconfont}" style="font-size: 20px"></span>`
    },
  },
  watch: {
    currentLevelValue(n) {
      const param = {
        index: this.index,
        v_answered: !!n,
      }
      let v_answer = {}
      // 设置当前题目已答
      this.$store.commit('setQuestionAnswered', param)
      if (!param.v_answered) {
        this.$store.commit('setQusstionUserAnswer', {
          index: this.index,
          v_answer,
        })
        // 取消回调
        this.$emit('onSelectCancel')
        return
      }
      v_answer = this.getValue()
      console.log(v_answer)
      //挂本道题用户答案
      this.$store.commit('setQusstionUserAnswer', {
        index: this.index,
        v_answer,
      })
      //把当前选中的选项传给父组件判断子题是否显示
      this.$emit('onSelectChange')
    },
  },
  methods: {
    filterHistory() {
      if (this.question.optionTag != 100) {
        let isHistory = false
        let his1 = false
        let his2 = false
        let his3 = false
        let len = this.question.options.length
        this.question.options.forEach((item, i) => {
          if (item.text == '2' && i == 1) {
            his1 = true
          }
          if (item.text == '3' && i == 2) {
            his2 = true
          }
          if (item.text == '4' && i == 3) {
            his3 = true
          }
        })
        if (len == 3) {
          isHistory = his1
        } else if (len == 4) {
          isHistory = his2
        } else if (len == 5) {
          isHistory = his3
        } else {
          isHistory = his1 && his2 && his3
        }
        this.isHistory = isHistory
      }
    },
    getValue(value) {
      // 如果有值
      let options = []
      let currentValue = []
      if (this.currentLevelValue) {
        // 需要 -1 个
        let tenantId =
          this.question.options[this.currentLevelValue - 1].tenantId
        if (tenantId) {
          options.push({
            tenantId: tenantId,
          })
          currentValue.push(tenantId)
        }
      }
      return {
        tenantId: this.question.tenantId,
        type: 'scale',
        currentLevelValue: this.currentLevelValue,
        options: options,
        currentValue: currentValue,
      }
    },
    validate() {
      return this.$validator.validate()
    },
  },
}
